// Registrars + Route Builder
import { LayoutRegistration } from 'json-react-layouts'

// Components
import { AdUnitRegistration } from 'component-library/advertising/AdUnit/AdUnit.routing'
import { InlineContentRegistration } from 'component-library/publication/ArticleBlockContent/ArticleBlockContent.routing'
import { SponsoredOutbrainRegistration } from 'component-library/advertising/SponsoredOutbrain/SponsoredOutbrain.routing'
import { TheWestPublicationRegistration } from 'component-library/templates/Publication/TheWestPublication/TheWestPublication.routing'
import { TheWestArticleRegistration } from 'component-library/templates/Publication/TheWestPublication/TheWestArticle.routing'
import { TheWestGalleryRegistration } from 'component-library/templates/Publication/TheWestPublication/TheWestGallery.routing'
import { StaticContentRegistration } from 'component-library/publication/ArticleBlockContent/ArticleBlockContent.routing'
import { SectionHeaderRegistration } from 'component-library/section-header/SectionHeader/SectionHeader.routing'
import { BreakingNewsRegistration } from 'component-library/content/BreakingNews/BreakingNews.routing'
import { BreadcrumbRegistration } from 'component-library/navigation/Breadcrumb/Breadcrumb.routing'
import { SearchRegistration } from 'component-library/search/SearchResults/SearchResults.routing'
import { IframeRegistration } from 'component-library/content/Iframe/Iframe.routing'
import { ProfileRegistration } from 'component-library/content/Profile/Profile.routing'
import { TheWestPageNotFoundRegistration } from 'component-library/errors/PageNotFound/TheWestPageNotFound/TheWestPageNotFound.routing'
import { TheWestSomethingWentWrongRegistration } from 'component-library/errors/SomethingWentWrong/TheWestSomethingWentWrong/TheWestSomethingWentWrong.routing'
import { HorizontalCricketWidgetRegistration } from 'component-library/widgets/cricket/HorizontalCricketWidget/HorizontalCricketWidget.routing'
import { NewsletterSignupRegistration } from 'component-library/banners/NewsletterSignup/NewsletterSignup.routing'
import { LinkBannerRegistration } from 'component-library/banners/LinkBanner/LinkBanner.routing'
import { ImageBannerRegistration } from 'component-library/banners/ImageBanner/ImageBanner.routing'
import { PromotionalCardRegistration } from 'component-library/cards/PromotionalCard/PromotionalCard.routing'
import { ProfileCardRegistration } from 'component-library/cards/ProfileCard/ProfileCard.routing'
import { ArticleHeroRegistration } from 'component-library/publication/ArticleHero/ArticleHero.routing'
import { SharingRegistration } from 'component-library/buttons/Sharing/Sharing.routing'
import { FeatureHeadlineRegistration } from 'component-library/publication/Headline/FeatureHeadline.routing'
import { TopicListRegistration } from 'component-library/content/TopicList/TopicList.routing'
import { OmnyRegistration } from 'component-library/publication/Embed/web/Omny.routing'

// internal static page content - only belonging to the west
import { RSSFeedsRegistration } from 'thewest/routes/static/RSS/RSS.routing'
import { LiveScoresRegistration } from 'component-library/widgets/cricket/LiveScores/LiveScores.routing'

// Collections (also technically components)
import { JulietRegistration } from 'component-library/collections-new/Juliet/Juliet.routing'
import { TheWestLimaRegistration as LimaRegistration } from 'component-library/collections-new/Lima/Lima.routing'
import { SierraRegistration } from 'component-library/collections-new/Sierra/Sierra.routing'
import { UniformRegistration } from 'component-library/collections-new/Uniform/Uniform.routing'
import { OscarRegistration } from 'component-library/collections-new/Oscar/Oscar.routing'
import { WhiskeyRegistration } from 'component-library/collections-new/whiskey/Whiskey.routing'

// Compositions
import { BoxRegistration } from 'component-library/compositions/Box/Box.routing'
import { ZeusRegistration } from 'component-library/compositions/Zeus/Zeus.routing'
import { ThorRegistration } from 'component-library/compositions/Thor/Thor.routing'
import { CerberusRegistration } from 'component-library/compositions/Cerberus/Cerberus.routing'
import { CerberusFourRegistration } from 'component-library/compositions/Cerberus/CerberusFour.routing'
import { FeatureCompositionRegistration } from 'component-library/compositions/FeatureComposition/FeatureComposition.routing'

// Features
import { JanusRegistration } from 'component-library/compositions/Janus/Janus.routing'
import { NovemberRegistration } from 'component-library/collections-new/November/November.routing'
import { MyHomeRegistration } from 'component-library/my-home/my-home.routing'
import { ComponentRendererErrorRegistration } from 'component-library/diagnostics/ComponentRendererError/ComponentRendererError.routing'
import {
    FailLoadContentRegistration,
    FailLoadContent404Registration,
} from 'component-library/diagnostics/FailLoadContent/FailLoadContent.routing'
import { userOverridesRegistration } from 'component-library/feature-toggling/ExperimentalFeatures/ExperimentalFeatures.routing'
import { ComponentServices, dataLoaderMiddleware } from 'common/routing/page-definition'
import {
    componentFeatureToggleMiddleware,
    compositionFeatureToggleMiddleware,
    componentOnEventMiddleware,
} from 'common/component-middlewares'
import { TheWestFeatureRegistration } from 'component-library/templates/Publication/TheWestPublication/TheWestFeature.routing'
import { FigCaptionRegistration } from 'component-library/publication/FigCaption/Figcaption.routing'
import { FeatureArticleBreachCompositionRegistration } from 'component-library/user-registration/breach/FeatureArticleBreach.routing'
import { QuickLinksRegistration } from 'component-library/navigation/QuickLinks/QuickLinks.routing'
import { StaticSubscribePromoCardRegistration } from 'component-library/cards/TWStaticSubscribeCard/TWStaticSubscribeCard.routing'
import { TWStaticAFLCardRegistration } from 'component-library/cards/TWStaticAFLCard/TWStaticAFLCard.routing'
import { TelethonCountdownRegistration } from 'component-library/advertising/TelethonCountdown/TelethonCountdown.routing'
import { AmpStickyAdUnitRegistration } from 'component-library/google-amp/components/AmpStickyAd.routing'
import { OurPublicationRegistration } from 'component-library/our-publications/our-publication.routing'
import { TheWestLivePlayerPageRegistration } from 'component-library/content/TheWestLive/TheWestLivePlayerPage/TheWestLivePlayerPage.routing'
import { RelatedContentRegistration } from 'component-library/content/RelatedContent/RelatedContent.routing'
import { CookieConsentUserSettingsPageRegistration } from 'component-library/cookie-consent/CookieConsentUserSettingsPage/CookieConsentUserSettingsPage.routing'

// Register Components & Collections
export const layout = new LayoutRegistration<ComponentServices>()
    .registerComponents(registrar =>
        registrar
            .registerComponent(ComponentRendererErrorRegistration)
            .registerComponent(FailLoadContentRegistration)
            .registerComponent(FailLoadContent404Registration)
            .registerComponent(userOverridesRegistration())

            // collections
            .registerComponent(JulietRegistration)
            .registerComponent(LimaRegistration)
            .registerComponent(SierraRegistration)
            .registerComponent(UniformRegistration)
            .registerComponent(OscarRegistration)
            .registerComponent(NovemberRegistration)
            .registerComponent(WhiskeyRegistration)

            // components
            .registerComponent(AdUnitRegistration)
            .registerComponent(AmpStickyAdUnitRegistration)
            .registerComponent(InlineContentRegistration)
            .registerComponent(SponsoredOutbrainRegistration)
            .registerComponent(TheWestPublicationRegistration)
            .registerComponent(TheWestArticleRegistration)
            .registerComponent(TheWestGalleryRegistration)
            .registerComponent(TheWestFeatureRegistration)
            .registerComponent(StaticContentRegistration)
            .registerComponent(SectionHeaderRegistration)
            .registerComponent(BreakingNewsRegistration)
            .registerComponent(BreadcrumbRegistration)
            .registerComponent(SearchRegistration)
            .registerComponent(IframeRegistration)
            .registerComponent(ProfileRegistration)
            .registerComponent(TheWestPageNotFoundRegistration)
            .registerComponent(TheWestSomethingWentWrongRegistration)
            .registerComponent(LiveScoresRegistration)
            .registerComponent(NewsletterSignupRegistration)
            .registerComponent(LinkBannerRegistration)
            .registerComponent(ImageBannerRegistration)
            .registerComponent(PromotionalCardRegistration)
            .registerComponent(ProfileCardRegistration)
            .registerComponent(ArticleHeroRegistration)
            .registerComponent(SharingRegistration)
            .registerComponent(FeatureHeadlineRegistration)
            .registerComponent(FigCaptionRegistration)
            .registerComponent(TopicListRegistration)
            .registerComponent(QuickLinksRegistration)
            .registerComponent(TelethonCountdownRegistration)
            .registerComponent(OmnyRegistration)
            .registerComponent(RelatedContentRegistration)

            // internal west components
            .registerComponent(RSSFeedsRegistration)
            .registerComponent(HorizontalCricketWidgetRegistration)
            .registerComponent(MyHomeRegistration)
            .registerComponent(StaticSubscribePromoCardRegistration)
            .registerComponent(TWStaticAFLCardRegistration)
            .registerComponent(OurPublicationRegistration)
            .registerComponent(TheWestLivePlayerPageRegistration)
            .registerComponent(CookieConsentUserSettingsPageRegistration)

            .registerMiddleware(componentFeatureToggleMiddleware)
            .registerMiddleware(dataLoaderMiddleware)
            .registerMiddleware(componentOnEventMiddleware)
    )
    .registerCompositions(registrar =>
        registrar
            .registerComposition(ZeusRegistration)
            .registerComposition(ThorRegistration)
            .registerComposition(BoxRegistration)
            .registerComposition(CerberusRegistration)
            .registerComposition(CerberusFourRegistration)
            .registerComposition(JanusRegistration)
            .registerComposition(FeatureCompositionRegistration)
            .registerComposition(FeatureArticleBreachCompositionRegistration)

            .registerMiddleware(compositionFeatureToggleMiddleware)
    )
